const React = require('react');

const Columns = require('../layout/Columns.jsx');
const CommonTypes = require('../common/Types.jsx');
const Component = require('../common/Component.jsx');
const Config = require('../utility/Config.jsx');
const Container = require('../common/Container.jsx');
const Item = require('../common/Item.jsx');
const ItemMeta = require('./ItemMeta.jsx');
const ItemV2 = require('../common/ItemV2.jsx');
const Name = require('../utility/Name.jsx');
const _TypeConfig = require('../common/TypeConfig.jsx');
const Utilities = require('../utility/Utilities.jsx');

const ItemBlocks = {
    get: (group, data) => [
        ...CommonTypes.BlocksV2.content.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: ItemV2.Image.Component,
            config: {
                Block: ItemV2.Image.TypeConfig.panel.block(),
                Style: ItemV2.Image.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: ItemMeta.Component,
            config: {
                Block: ItemMeta.TypeConfig.panel.block(),
                Style: ItemMeta.TypeConfig.panel.style(),
                Description: ItemMeta.TypeConfig.panel.description(),
                Label: ItemMeta.TypeConfig.panel.label(),
                Value: ItemMeta.TypeConfig.panel.value(data)
            },
            display: 'Item Meta',
            group,
            image: ''
        }
    ]
}

function ItemContainerV2(props) {
    const config = props.config || {};
    if (!props.builder && !props.forceVisibility && !Utilities.Config.getVisibility(config, 'Inventory')) {
        return null;
    }
    const artist = props.itemData || {};
    const inventory = artist.Inventory || [];
    if (!props.builder && inventory.length == 0) {
        return null;
    }
    const blockConfig = config.config && config.config.Block || {};
    let columnCount = 3;
    if (blockConfig.columnCount) {
        let temp = parseInt(blockConfig.columnCount, 10);
        if (!isNaN(temp) && temp > 0) {
            columnCount = temp;
        }
    }
    let contentConfig;
    if (blockConfig.design && blockConfig.design.Config && blockConfig.design.Config.blocks && blockConfig.design.Config.blocks.length > 0) {
        contentConfig = blockConfig.design;
    }
    let content = [];
    for (let i = 0; i < columnCount; i++) {
        if (i < inventory.length) {
            content.push(
                <td key={i} style={{ width: `${100.0 / columnCount}%` }}>
                    <ItemContentContainer
                        config={contentConfig}
                        data={props.data}
                        itemData={inventory[i]}
                        kit={props.kit}
                        serverSide={props.serverSide} />
                </td>
            )
        } else {
            content.push(<td key={i} style={{ width: `${100.0 / columnCount}%` }} />)
        }
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            dataType="layout"
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                {content}
                {
                    props.builder &&
                    <td>
                        {
                            !contentConfig &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                }
            </tr>
        </Container>
    );
}
const ItemContentContainer = Config.withBlockRendering(ItemV2.Container.Component, ItemBlocks.get(), (props) => {
    let data = props.itemData || props.data || {};
    if (data.Artists && data.Artists.length > 0 && data.Artists[0].Inventory && data.Artists[0].Inventory.length > 0) {
        data = data.Artists[0].Inventory[0];
    }
    return { itemData: data };
});

const TypeConfigV2 = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "maxHeight": {
                                "unit": "px",
                                "value": "160"
                            },
                            "maxWidth": {
                                "unit": "px",
                                "value": "160"
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "left"
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {},
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ItemMeta.TypeConfig.defaultDesign(data)
                        }
                    },
                    "id": `${Name.Block.Inventory.Meta}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.ArtistInventoryItem
    }),
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Item Count',
                        group,
                        name: 'columnCount',
                        options: [
                            { display: '1', value: '1' },
                            { display: '2', value: '2' },
                            { display: '3', value: '3' }
                        ],
                        type: 'dropdown',
                        value: '3'
                    },
                    {
                        display: 'Edit Item Content',
                        fullWidth: true,
                        group,
                        type: 'edit-button',
                        value: {
                            keyPath: ['Block', 'design'],
                            name: Name.Content.ArtistInventoryItem
                        }
                    }
                ]
            }
        },
        style: () => _TypeConfig.panel.layoutStyleV2('block', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                options: [
                    {
                        configurableDuringExport: () => true,
                        display: 'Artworks',
                        name: 'Inventory',
                        type: 'checkbox',
                        value: true,
                        visible: () => false
                    }
                ]
            };
        }
    }
}

// #region LEGACY

class _ItemContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handleColumnProps = this.handleColumnProps.bind(this);
        this.handleComponentType = this.handleComponentType.bind(this);
    }

    handleColumnProps(index) {
        if (!this.props.builder || index == 0) {
            return {};
        }
        return { disabled: true };
    }

    handleComponentType(type) {
        switch (type) {
            case 'itemDimensions':
                return Item.Dimensions.Component;
            case 'itemImage':
                return Item.Image.Component;
            case 'itemPrice':
                return Item.Price.Component;
            case 'itemTitle':
                return Item.Title.Component;
            default:
                return null;
        }
    }

    render() {
        const config = this.props.config || {};
        if (!this.props.builder && !this.props.forceVisibility && !Utilities.Config.getVisibility(config, 'Inventory')) {
            return null;
        }
        const artist = this.props.itemData || {};
        const inventory = artist.Inventory || [];
        if (!this.props.builder && inventory.length == 0) {
            return null;
        }
        let columnCount = 3;
        if (config.Config && config.Config.Block) {
            let temp = parseInt(config.Config.Block.columnCount, 10);
            if (!isNaN(temp) && temp > 0) {
                columnCount = temp;
            }
        }
        let columns;
        if (config.Columns && config.Columns.length > 0) {
            columns = [];
            for (let i = 0; i < columnCount; i++) {
                columns.push(config.Columns[0]);
            }
        }
        const componentData = inventory.map(function (d, i) { return { index: i, itemData: d }; })
        while (componentData.length < columnCount) {
            // Pad with empty column content
            componentData.push(this.props.builder ? { index: componentData.length } : undefined);
        }
        return (
            <Columns.V1.Component
                {...this.props}
                columns={columns}
                componentData={componentData}
                dataType="layout"
                renderHeader={this.props.builder == true}
                typeHandler={this.handleComponentType}
                onColumnProps={this.handleColumnProps} />
        );
    }
}
const ItemContainer = Component.withBlockComponentHandler(_ItemContainer);

const TypeConfig = {
    panel: {
        block: function () {
            return {
                label: 'Block Configuration',
                options: [
                    {
                        display: 'Item Count',
                        name: 'columnCount',
                        options: [
                            { display: '1', value: '1' },
                            { display: '2', value: '2' },
                            { display: '3', value: '3' }
                        ],
                        relatedProperties: [
                            'col1_width',
                            'col2_width',
                            'col3_width',
                            'col2_verticalAlign',
                            'col3_verticalAlign',
                            'col2_collapseIfEmpty',
                            'col3_collapseIfEmpty'
                        ],
                        type: 'dropdown',
                        value: '3'
                    },
                    ...Columns.V1.TypeConfig.options.column(
                        { display: 'Item 1 Properties', number: 1 },
                        {},
                        {
                            default: {
                                '1': '100%',
                                '2': '50%',
                                '3': '33.33%'
                            },
                            relatedProperty: 'columnCount',
                            value: '33.33%',
                            visible: function () { return false; }
                        },
                        { visible: function () { return false; } },
                        {}
                    ),
                    { type: 'spacer' },
                    { type: 'spacer' },
                    ...Columns.V1.TypeConfig.options.column(
                        { display: 'Item 2 Properties', number: 2 },
                        { visible: function (config) { return config.Block && (config.Block.columnCount == '2' || config.Block.columnCount == '3'); } },
                        {
                            default: {
                                '1': undefined,
                                '2': '50%',
                                '3': '33.33%'
                            },
                            relatedProperty: 'columnCount',
                            value: '33.33%',
                            visible: function () { return false; }
                        },
                        { visible: function () { return false; } },
                        {
                            default: {
                                '1': undefined,
                                '2': 'top',
                                '3': 'top'
                            },
                            relatedProperty: 'columnCount'
                        },
                        {
                            default: {
                                '1': undefined,
                                '2': true,
                                '3': true
                            },
                            relatedProperty: 'columnCount',
                            visible: function () { return false; }
                        }
                    ),
                    {
                        type: 'spacer',
                        visible: function (config) {
                            return config.Block && config.Block.columnCount == '3';
                        }
                    },
                    {
                        type: 'spacer',
                        visible: function (config) {
                            return config.Block && config.Block.columnCount == '3';
                        }
                    },
                    ...Columns.V1.TypeConfig.options.column(
                        { display: 'Item 3 Properties', number: 3 },
                        { visible: function (config) { return config.Block && config.Block.columnCount == '3'; } },
                        {
                            default: {
                                '1': undefined,
                                '2': undefined,
                                '3': '33.33%'
                            },
                            relatedProperty: 'columnCount',
                            value: '33.33%',
                            visible: function () { return false; }
                        },
                        { visible: function () { return false; } },
                        {
                            default: {
                                '1': undefined,
                                '2': undefined,
                                '3': 'top'
                            },
                            relatedProperty: 'columnCount'
                        },
                        {
                            default: {
                                '1': undefined,
                                '2': undefined,
                                '3': true
                            },
                            relatedProperty: 'columnCount',
                            visible: function () { return false; }
                        }
                    ),
                ]
            };
        },
        columns: function () { return [[]]; },
        style: Columns.V1.TypeConfig.panel.style,
        visibility: function () {
            return {
                options: [
                    {
                        configurableDuringExport: function () { return true; },
                        display: 'Artworks',
                        name: 'Inventory',
                        type: 'checkbox',
                        value: true,
                        visible: function () { return false; }
                    }
                ]
            };
        }
    }
};

// #endregion LEGACY

module.exports = {
    Blocks: ItemBlocks,
    ContentContainer: ItemContentContainer,
    ComponentV2: ItemContainerV2,
    TypeConfigV2,

    // LEGACY
    Component: ItemContainer,
    TypeConfig
};